import Translatable from "@/components/translatable_text/Translatable";
import DevelopedProject from "./DevelopedProject";

function Story() {
  return (
    <section className="d-rotate wow">
      <div className="container">
        <div className="flex justify-center">
          <div className="w-full lg:w-11/12">
          <div className="cont pb-12 md:pt-16 border-gray-200 rotate-text">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
                <div className="md:col-span-3 mb-8 md:mb-0">
                  <h6 className="text-xl md:text-2xl lg:text-3xl font-semibold text-gray-800"><Translatable>Products Built with TPPM</Translatable></h6>
                </div>
                <div className="md:col-span-9">
                  <div className="text">
                    <p className="text-gray-600 leading-relaxed md:leading-loose text-base md:text-lg">
                      <Translatable>
                        Every product listed here was developed under GCAD’s Technology Project Protocol Management (TPPM) — the internal standard that governs how ideas move from strategy to production. By following the CoreStack → CoreBuild protocol, these products meet consistent benchmarks for quality, scalability, and reliability.
                      </Translatable>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <DevelopedProject />

            <div className="cont mb-120 border-gray-200 rotate-text">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
                <div className="md:col-span-3 mb-8 md:mb-0">
                  <h6 className="text-xl md:text-2xl lg:text-3xl font-semibold text-gray-800"><Translatable>Protocol-Driven Assurance</Translatable></h6>
                </div>
                <div className="md:col-span-9">
                  <div className="text">
                    <p className="text-gray-600 leading-relaxed md:leading-loose text-base md:text-lg">
                      <Translatable>
                        Products developed under TPPM are not one-off builds — they are repeatable, auditable, and scalable systems. Each solution reflects GCAD’s commitment to disciplined delivery, responsible technology, and long-term value creation.
                      </Translatable>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Story;
